export const mobileApp_by = {
    head: "Мабільнае ",
    headStrong: "прыкладанне",
    desc1: "Запампуйце і ўсталюйце прыкладанне Clever для мабільнай і хуткай працы з вашым акаўнтам. Рэдагуйце, стварайце стэнды і прызначайце сустрэчы з вашых кішэнных гаджэтаў.",
    desc2: "З прыкладаннем Clever заўсёды пад рукой!",
}